import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
//import Button from '@mui/material/Button';
//import IconButton from '@mui/material/IconButton';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import MixpanelButton from "../MixpanelButton";

import Footer from './Footer';
import HeaderBar from './HeaderBar';

import { MixpanelProvider } from 'react-mixpanel';
import mixpanel from '../../utils/mixpanel';

const useStyles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
    width: '100%',
    margin: '2rem auto',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  box: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    textTransform: 'capitalize',
  },
  signOut: {
    backgroundColor: '#ff2f05',
    color: 'white',
  },
  extraItems: {
  },
  footer: {
    marginTop: 'auto',
  },
});

class DashboardTemplate extends Component {
  render() {
    const { classes } = this.props;
    const { children } = this.props;
    const { prependItems, appendItems } = this.props;
    let { maxWidth } = this.props;
    if (maxWidth == null) {
      maxWidth = 'md'; // xs sm md lg xl
    }

    return (
      <MixpanelProvider mixpanel={mixpanel}>
        <div className={classes.root}>
          <CssBaseline />
          <HeaderBar className={classes.appBar}>
            <MixpanelButton mixpanelMessage="kiara_app_com_header_menu_dashboard" href="/dashboard" color="secondary" aria-label="Dashborad" size="small">
              <Box component="span" display={{ xs: 'none', md: 'inline' }} className={classes.box} >Dashboard</Box>
            </MixpanelButton>
            <MixpanelButton mixpanelMessage="kiara_app_com_header_menu_help" href="https://www.getkiara.com/help" color="secondary" aria-label="Help" size="small" >
              <Box component="span" display={{ xs: 'none', md: 'inline' }} className={classes.box} >Help   </Box>
            </MixpanelButton>
            <MixpanelButton mixpanelMessage="kiara_app_com_header_menu_sign-out" href="/sign-out" color="primary" aria-label="Sign out" size="small" className={classes.signOut}>
              <Box component="span" display={{ xs: 'none', md: 'inline' }} className={classes.box} >Sign out</Box>
            </MixpanelButton>
          </HeaderBar>
          <Container component="main" maxWidth={maxWidth} className={classes.root}>
            <Box className={classes.extraItems}>
              {prependItems}
            </Box>
            <Card className={classes.paper} elevation={0}>
              {children}
            </Card>
            <Box className={classes.extraItems}>
              {appendItems}
            </Box>
          </Container>
          <Footer />
        </div>
      </MixpanelProvider>
    );
  }
}

export default withStyles(useStyles)(DashboardTemplate);